import { useSearchParams } from "react-router-dom";
import ReferencePayment from "../features/referencePayment/ReferencePayment";
import { derashPaymentService } from "../features/referencePayment/referencePaymentServices";

const Derash = () => {
  const [searchParams] = useSearchParams();

  return (
    <ReferencePayment
      service={derashPaymentService}
      context={{
        billerCode: searchParams.get("billerCode") ?? "",
        billerName: searchParams.get("billerName") ?? "",
      }}
    />
  );
};

export default Derash;
